import axios from 'axios';
import awsExports from 'aws-exports';
import { adminAPI } from 'services/admin';

export const useUploader = ({ variant = 'videos' } = { variant: 'videos' }) => {
  const uploadThumbFile = async ({ file, id, version, type }) => {
    try {
      const thumbUrl = await adminAPI.post(
        `/admin/${variant}/${id}/versions/${version}/thumbnail`,
        {
          body: {
            parts: 1,
            mimeType: file.type,
            extension: file.name.split('.').pop(),
            fileName: file.name,
            type,
          },
        }
      );

      const signUrlUpload = thumbUrl.multipartUpload.parts[0].signedUrl;
      const uploadId = thumbUrl.multipartUpload.uploadId;
      const fileKey = thumbUrl.multipartUpload.fileKey;

      const thumbUpload = await axios.put(signUrlUpload, file, {
        headers: {
          'Content-Type': '',
        },
      });

      const eTag = thumbUpload.headers['etag'];
      await adminAPI.post('/admin/multipart-upload-complete', {
        body: {
          uploadId,
          fileKey,
          parts: [
            {
              partNumber: 1,
              eTag: eTag.replace(/"/g, ''),
            },
          ],
        },
      });

      return {
        type,
        url: awsExports.ENDPOINT_THUMBNAIL + '/' + fileKey,
        tempURL: URL.createObjectURL(file),
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    uploadThumbFile,
  };
};
